import { createAction, props } from '@ngrx/store';
import { MemberForm } from '../../models';

export const SubmitMemberForm = createAction('[Member Form] Submit MemberForm', props<{ memberForm: MemberForm }>());
export const SubmitMemberFormSuccess = createAction('[Member Form] Submit MemberForm success', props<{ memberForm: MemberForm }>());
export const SubmitMemberFormFail = createAction('[Member Form] Submit MemberForm Fail', props<{ error: any }>());
export const ResetMemberForm = createAction('[Member Form] Reset form');
